import MassMessage from "./MassMessage";
export default MassMessage;
